module.exports = __webpack_public_path__ + "img/art.c8b2ea40.jpg";